<template>
  <div id="page-letter-request" class="d-flex">
    <div class="layout-content container-fluid d-flex">
      <!--HeadingUser  h-100 scrollable flex-shrink-0" style="max-height: 85vh/-->
      <div class="page-letter-request py-0">
        <div class="container"  style="border:1px solid #cecece;">
          <b-tabs content-class="mt-3">
          <b-tab title="Permiso">
            <div class="row">
              <div class="col-12">
                <img align="center" width="420" height="100" 
                  :src="serverPath+'/'+this.template.template.header_img"
                  @error="imageLoadError"
                >
              </div> 
            </div>
            <div class="row">
              <div class="col-12">
                <p class="p3"><br>
                  {{this.requestBy.city.name}}, {{this.template.request_date.substring(0,10)}}<br>
                  Sres.<br>
                  Bavaria S.A<br>                
                  <b class="p1">{{this.template.bp_name}}</b><br>
                  <i>Business Partner</i><br>
                  <br>
                  Ref: Permisos Sindicales<br>
                  <br>
                  Cordial saludo,<br>
                  <b class="p1">{{this.requestBy.name}}, {{this.requestBy.position}} del {{this.requestBy.labor_union}}</b>, me dirijo a 
                  ustedes para informarles entre los días<b class="p1"> {{this.template.start_date}} al {{this.template.end_date}}</b> con motivo de
                  <b class="p1"> {{this.template.reason}} </b> solicitamos los permisos sindicales correspondientes para 
                  los siguientes socios:<br><br>                
                  <b class="p1">
                    <span v-for="item in this.template.license_employees" :key="item.core_employee.sharp_id">
                      {{ item.core_employee.name }},
                    </span>
                  </b>
                  <span v-show="this.template.tickets == 1">
                    <br><br>
                    De acuerdo a la convención colectiva de trabajo también solicitamos viáticos y tiquetes.
                  </span>
                  <br>
                  Ciudad de la actividad: <b class="p1">{{this.template.license_employees[0].ticket.destination_city_name}}.</b>
                  <br><br>
                  {{this.template.legal_context}}<br><br>
                  <b class="p1">{{this.template.aditional_info}}</b><br><br>
                  Agradezco la atención prestada y quedo atento a su pronta respuesta.<br> 
                  Cordialmente.

                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <img align="center" style="width:100px;height:100px;"
                  :src="serverPath+'/'+template.template.signature1"
                  @error="imageLoadError"
                >
              </div>
              <div class="col-6">
                <img align="center" style="width:100px;height:100px;"
                  :src="serverPath+'/'+template.template.signature2"
                  @error="imageLoadError"
                >
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p class="p3">{{this.template.template.name1}}</p>
              </div>
              <div class="col-6">
                <p class="p3">{{template.template.name2}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <p class="p3">{{template.template.position1}}</p>
              </div>
              <div class="col-6">
                <p class="p3">{{template.template.position2}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <img align="center" width="520" height="100" 
                :src="serverPath+'/'+template.template.footer_img"
                @error="imageLoadError"
                >
              </div>
            </div>
          </b-tab>
          <b-tab title="Respuesta" active>
            <div class="row layout-content container-fluid d-flex">
              <div class="col-12">
                  <img align="center" width="475" height="100" 
                  :src="serverPath+this.bpSociety.name.header_img" 
                  @error="imageLoadError"
                  alt="">
                </div>
              <p class="p3"><br>
              {{this.requestBy.city.name}}, {{this.template.request_date.substring(0,10)}} <br>
              Señores  {{this.requestBy.labor_union}} <br>
              Sr. {{this.requestBy.name}}<br> 
              Asunto: Respuesta a solicitud de permiso sindical del {{this.template.request_date.substring(0,10)}} <br><br>
              En atención a su solicitud del permiso sindical {{this.$route.params.id}}, la Empresa 
              respetuosa de los derechos de Asociación y Libertad Sindical, soportados bajo 
              la legislación vigente y la Jurisprudencia de la Corte Constitucional, y 
              entendiendo que la Organización Sindical ha evaluado la solicitud de los permisos 
              bajo los principios de necesidad, proporcionalidad y razonabilidad, para el 
              ejercicio de su actividad sindical, se han aprobado tal y como se indica a continuación:<br><br>
              
              <table border="1" width="100%">
                  <thead>
                    <tr align="center" bgcolor="#c4c4c4">
                      <td><b class="p1">ID HCM</b></td><td><b class="p1">Colaborador</b></td><td><b class="p1">Días de permiso</b></td>
                    </tr>
                  </thead>
                  <tbody v-for="colaborador in colaboradores" :key="colaborador.core_employee.sharp_id" align="center">
                    <tr v-if="colaborador.approvalString">
                      
                      <td>
                        {{colaborador.core_employee.hcm_id}}
                      </td>
                      
                      <td>
                        {{colaborador.core_employee.name}}
                      </td>
                      <td>
                        {{colaborador.approvalString}}
                      </td>
                      
                    </tr>
                  </tbody>
                </table>
                <br><br><b>Por las razones descritas en cada caso, no se pueden otorgar los siguientes permisos:</b><br><br>
                <table border="1" width="100%">
                  <thead>
                    <tr align="center" bgcolor="#c4c4c4">
                      <td><b class="p1">ID HCM</b></td><td><b class="p1">Colaborador</b></td><td><b class="p1">Días de permiso</b></td><td><b class="p1">Motivo</b></td>
                    </tr>
                  </thead>
                  <tbody v-for="colaborador in colaboradores" :key="colaborador.core_employee.sharp_id" align="center">
                    <tr v-if="colaborador.rejectedString">
                      <td>
                        {{colaborador.core_employee.hcm_id}}
                      </td>                      
                      <td>
                        {{colaborador.core_employee.name}}
                      </td>
                      <td>
                        {{colaborador.rejectedString}}
                      </td>
                      <td bgcolor="#edabab">
                        <b class="p1">
                          {{colaborador.reason}}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
            </p>
            </div>
            <div class="row">
                <div class="col-12">
                  <img align="center" width="475" height="100" 
                  :src="serverPath+this.bpSociety.name.footer_img"
                  @error="imageLoadError"
                  >
                </div>
            </div>
          </b-tab>
        </b-tabs>
        </div>
      <!-- .layout-content -->
      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";

export default {
  props: {
    id: {
      type: String
    },
  },
  name: "TemplateLetterFree",
  components: {  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-valid
        message: "",
      },      
      template: [],
      monthNames: ["cero", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      colaboradores: [],
      tiquetes: '',
      ciudadActividad: '',
      bpSociety: [],
      requestBy: [],
    };
  },
  beforeMount() {
    var data = [];
    data[0] = this.$route.params.id;
    data[1] = this.$route.params.idUser;
    
    this.actGetRequestFree(data).then(() =>{                  
                  this.template = this.requestFree.data;
                  this.requestBy = this.requestFree.data.requested_by;
                  this.colaboradores = this.requestFree.data.license_employees;
                  this.bpSociety = this.requestFree.data.society;
                  this.loadInfoDates();
                    
                }).catch((response) => {
                  this.error.flag = true;
                  this.error.class = "is-invalid";
                  this.error.message = "No se pudo conectar al servicio: "+response;
                });
  
  }, 
  computed: {
    ...mapState("modRequest", ["requestFree"]),
  },
  methods: {
    ...mapActions("modRequest", [
    "actGetRequestFree",
    ]),
    
    loadInfoDates(){
      let monthsA = [];
      let monthsR = [];
      for(let i=0; i<this.colaboradores.length; i++){
        monthsA = [];
        monthsR = [];
        this.colaboradores[i]['approvalString'] = "";
        this.colaboradores[i]['rejectedString'] = "";        
        for(let j=0; j<this.colaboradores[i].days.length; j++){          
          if(this.colaboradores[i].days[j].status == 'approved'){            
            this.colaboradores[i]['approvalString'] += this.colaboradores[i].days[j].day.substring(8,10)+ ', ';            
            monthsA.push(this.monthNames[parseInt(this.colaboradores[i].days[j].day.substring(5,7))]);
          }
          if(this.colaboradores[i].days[j].status == 'rejected'){            
            this.colaboradores[i]['rejectedString'] += this.colaboradores[i].days[j].day.substring(8,10)+ ', ';            
            monthsR.push(this.monthNames[parseInt(this.colaboradores[i].days[j].day.substring(5,7))]);
          }
        }
        // Generamos los meses para imprimir 1 sola vez        
        if(this.colaboradores[i]['approvalString']){
          let months1 = this.uniq(monthsA);
          months1.forEach(element => {
            this.colaboradores[i]['approvalString'] += " "+element;
          });          
        }
        if(this.colaboradores[i]['rejectedString']){
          let months2 = this.uniq(monthsR);
          months2.forEach(element => {
            this.colaboradores[i]['rejectedString'] += " "+element;
          });          
        }
      }
    },
    
    imageLoadError(event) {
      event.target.src = "";
    },

    uniq(a) {
      var seen = {};
      var out = [];
      var len = a.length;
      var j = 0;
      for(var i = 0; i < len; i++) {
          var item = a[i];
          if(seen[item] !== 1) {
                seen[item] = 1;
                out[j++] = item;
          }
      }
      return out;
    }
  },
};
</script>

<style lang="scss">
//@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.page-letter-request {
  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 16px;
    color: #303030;
    padding-left: 5%;
    text-align: right;
    vertical-align: bottom;
    text-decoration: underline;
  }
  .p3 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #454545;
  }
  
  img {
    width: 100%;
    height: auto;
  }
}
</style>